import { useContext, useEffect, useState } from 'react'
import { X } from '@phosphor-icons/react'

import { SL_Modal } from '../../../../components/modal/Modal'
import { SectorMap } from './SectorMap'
import { PaginationSectors } from './PaginationSectors'

import { getColorByLuminosity, getIcon, hexToRgba } from '../../../../helpers/helper'
import { GeneralContext } from '../../../../context/GeneralContext/GeneralContext'
import { colors } from '../../../../services/style'
import { ECentralActions } from '../../../../enums/ECentralActions'
import api from '../../../../services/api'

export const CentralModal = ({ data, onClose, onClickUserActionButton }) => {
    const { windowWidth, mobile_mode, windowHeight } = useContext(GeneralContext)
    const modalVW = 56.25
    const vwFigma = 31.82
    const vhFigma = 51.85

    const modalWidth = mobile_mode ? windowWidth * 0.9 : windowWidth * (modalVW / 100)
    const [sectorActive, setSectorActive] = useState(data?.sectors?.[0])
    const [imageSrc, setImageSrc] = useState(null)

    const generateAlertStyles = (sector) => {
        const sectorsStyle = {
            backgroundColor: '',
            border: '',
        }

        const activeStyles = {
            backgroundColor: hexToRgba(sector.devices?.[0]?.color, 0.4),
            border: `solid 1.5px ${sector.devices?.[0]?.color}`,
        }
        return sector.alert_counts ? activeStyles : sectorsStyle
    }

    const generalActions = Object.values(ECentralActions)
    const sectors = data.sectors.map((sector) => ({
        label: (
            <div id={`sector-${sector.id}`} className="flex items-center justify-center p-1 rounded-[8px] central-modal-title-tab" style={generateAlertStyles(sector)}>
                <span className="text-medium central-modal-title-tabs-text">{sector.name}</span>

                {sector.alert_counts ? (
                    <div style={{ backgroundColor: sector.devices?.[0]?.color }} className="rounded-full central-modal-general-footer-quantity">
                        <span className="font-semibold">{sector.alert_counts}</span>
                    </div>
                ) : null}
            </div>
        ),
        key: sector.id,
    }))

    const getImageFromSector = async (active) => {
        if (!active) return
        try {
            const { data } = await api.sectors.getFloorPlant(active.id)
            setImageSrc(data)
        } catch (error) {
            console.log(error)
        } finally {
        }
    }

    const onChangeTab = (value) => {
        const active = data.sectors.find((sec) => sec.id == value)
        setSectorActive(active)
        getImageFromSector(active)
    }

    const title = (
        <div className={`flex justify-between flex-wrap central-modal-title-div text-white`}>
            <span className="mt-2 font-medium central-modal-title">{data.central_name}</span>

            <div className="flex">
                <PaginationSectors sectors={data.sectors} onSelect={onChangeTab} active={sectorActive} dropdownHeigth={(vhFigma * windowHeight) / 100}/>
                <X color={colors['sl-gray'][50]} className="cursor-pointer settings-modal-configs-icon" onClick={onClose} />
            </div>
        </div>
    )

    const getGeneralButtonColor = (key) => {
        const { should_activate_general_alert_buttton, should_activate_group_alert_button } = data.general_buttons_data

        switch (key) {
            case ECentralActions.GENERAL_ALERT.code:
                if (should_activate_general_alert_buttton) return 'bg-sl-red-200'
                break
            case ECentralActions.GROUP_ALERT.code:
                if (should_activate_group_alert_button) return 'bg-sl-red-200'
                break
        }
        return 'gradient-button'
    }

    useEffect(() => {
        onChangeTab(data?.sectors?.[0]?.id)
    }, [])

    return (
        <SL_Modal
            open={true}
            closable={false}
            footer={
                <div className={`grid gap-2 grid-cols-5`} style={{ borderTop: `1.5px solid ${colors['sl-gray'][150]}` }}>
                    {Object.values(data.count_by_alert).map((alert, index) => (
                        <div key={`alerta-centralModal-${index}`}>
                            <div className="flex flex-col central-modal-general-footer items-center justify-center">
                                <div className="flex justify-center items-center central-modal-general-footer-symbols">
                                    {getIcon(alert.type, alert.color, '2.22vh')}
                                    {alert.quantity ? (
                                        <div style={{ backgroundColor: alert.color, color: getColorByLuminosity(alert.color) }} className="rounded-full central-modal-general-footer-quantity">
                                            <span className="font-semibold">{alert.quantity}</span>
                                        </div>
                                    ) : null}
                                </div>
                                <div className="flex justify-center items-center uppercase">
                                    <span className="central-modal-general-footer-alert">{alert.label}</span>
                                </div>
                            </div>
                            <div
                                style={
                                    alert.quantity
                                        ? {
                                            boxShadow: `${hexToRgba(alert.color, 0.5)} 0px -6px 8px 4px`,
                                            height: 0,
                                            margin: '0px 10px',
                                            backgroundColor: 'transparent',
                                        }
                                        : { display: 'none' }
                                }
                            ></div>
                        </div>
                    ))}
                </div>
            }
            width={modalWidth}
            title={title}
        >
            <div className="flex flex-col gap-3">
                <div
                    className={`grid grid-cols-4  central-modal-general-actions`}
                    style={{ borderTop: `1.5px solid ${colors['sl-gray'][150]}`, borderBottom: `1.5px solid ${colors['sl-gray'][150]}` }}
                >
                    {generalActions.map((action) => (
                        <div
                            key={action.label}
                            onClick={() => onClickUserActionButton(action.code)}
                            className={` rounded flex flex-col  items-center justify-center w-full cursor-pointer central-modal-general-action ${getGeneralButtonColor(action.code)}`}
                        >
                            <img src={action.icon} className="central-modal-general-action-icon" />
                            <span className="text-medium central-modal-general-action-text">{action.label}</span>
                        </div>
                    ))}
                </div>
                <SectorMap img={imageSrc} sector={sectorActive} height={(vhFigma * windowHeight) / 100} width={(vwFigma * windowWidth) / 100} />
            </div>
        </SL_Modal>
    )
}
